/**
*   配置文件
*   2023-10-10
*/
const CNF = {
    'api' : 'http://120.79.143.98:18092/v1/',
    // 'api' : 'http://127.0.0.1:8092/v1/',
    'projectCode': '',
    'projectName': '新致腾官网',
    'version': '1.0.0',
    'basename': '',
    'navItems': [
        {label: '网站首页',key: 'home'},
        {label: '产品服务',key: 'services'},
        {label: '解决方案',key: 'solutions'},
        {label: '案例展示',key: 'cases'},
        {label: '关于我们',key: 'aboutus'},
        {label: '新闻动态',key: 'news'},
        {label: '联系我们',key: 'contacts'},
    ],
    'pageSize': 10,
}

export default CNF;